import {
  instance as axios,
  setJwtToken,
} from "../../config/axiosInstance";

// ------------------------Change Password------------------
export const changePasswordApi = async (data) => {
  const endPoint = `profile/change_password`;
  return await axios.put(endPoint, data, setJwtToken());
};